var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reason",style:({
    backgroundColor: _setup.isTermination ? _setup.PaletteColors['danger-lighten-80'] : _setup.PaletteColors['default'],
    color: _setup.isTermination ? _setup.PaletteColors['danger-darken-10'] : _setup.PaletteColors['base-white'],
  })},[_vm._v(" "+_vm._s(_setup.getReasonLabel(_setup.props.reasonOptions, _setup.props.reason))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }